import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import HomePageEN from "./pages/HomePageEN";
import ThankYouPage from "./pages/ThankYouPage";
import ThankYouPageEN from "./pages/ThankYouPageEN";
import { Toaster } from "./components/ui/toaster";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/en" element={<HomePageEN />} />
          <Route path="/merci" element={<ThankYouPage />} />
          <Route path="/thank-you" element={<ThankYouPageEN />} />
          <Route path="/en/thank-you" element={<ThankYouPageEN />} />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;